module.exports = __webpack_public_path__ + "img/kkweb.839b3a77.svg";